import React, { useEffect } from 'react'
import { Field as FieldConf, getFieldLabel } from 'src/config'
import * as types from '../../../types'
import { TextField, Box, Switch, FormControl, FormControlLabel, InputLabel, FormHelperText, Input, OutlinedInput, MenuItem, Typography } from '@mui/material'
import Select, { SelectChangeEvent } from '@mui/material/Select';
import _ from 'lodash'

const BooleanField: React.FC<{
    field: FieldConf,
    value?: string,
    onChange: (value: types.Value) => void,
    options: { [key: string]: string },
    disabled?: boolean
    errors?: types.Error[],
    // options?: types.EntityOptions
}> = ({
    field,
    value,
    onChange,
    options,
    disabled = false,
    errors = [],
    // options
}) => {
        const { name, label, description, required } = field;

        const handleChange = (event: SelectChangeEvent) => {
            onChange(event.target.value as string);
        };

        return (

            <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth size="small">
                    <InputLabel
                        htmlFor={'field-' + name}
                        sx={{ color: theme => required ? theme.palette.error.main : theme.palette.text.primary }}
                    >
                        {getFieldLabel(field)}
                    </InputLabel>
                    <Select
                        labelId={name}
                        id={name}
                        value={value}
                        label={name}
                        onChange={handleChange}
                        disabled={disabled}
                        required={required}
                        error={errors.length > 0}
                    >
                        {
                            _.entries(options)
                                .map(([val, label], index) => <MenuItem value={val} key={index}>{label}</MenuItem>)
                        }
                    </Select>
                </FormControl>
            </Box>
        )
    }

export default BooleanField;